import React from 'react';
import connect from 'Shared/connect';
import classnames from 'classnames';
import * as styles from '../base.scss';
import MyMenigoIcon from '../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon';
import ProductImage from 'Shared/ProductComponents/ProductImage';
import Price from './ProductListItemPrice';
import { getSelectedVariant } from 'Shared/Product/reducer';
import { setGa4ItemListReferrel } from '../../../TrackingInformation';
import { pushState } from 'Shared/history';
const ProductListItem = ({ isLoggedIn, isSupplierSalesman, selectedVariant, product, index, itemListId }) => {
    const url = product.isDiscontinued && product.replacementProduct
        ? product.replacementProduct.url.toString()
        : !product.isDiscontinued && product.url.toString();
    const locationId = itemListId && `${itemListId}_${index + 1}`;
    const onProductClick = (event) => {
        if (!itemListId || event.ctrlKey || event.metaKey || !url)
            return;
        event.preventDefault();
        setGa4ItemListReferrel(itemListId);
        const ga4ItemListReferrel = JSON.stringify({
            itemListId,
            itemListName: itemListId,
            locationId,
            index: index + 1,
        });
        const separator = url.toString().includes('?') ? '&' : '?';
        pushState(`${url}${separator}ga4ItemListReferrel=${encodeURIComponent(ga4ItemListReferrel)}`);
        document.dispatchEvent(new CustomEvent('PeeriusTrackingClick', { detail: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.code }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { href: url, className: styles.product_list__link, onClick: onProductClick }),
        React.createElement("div", { className: styles.product_list__row },
            React.createElement("div", { className: styles.product_list__image },
                React.createElement(ProductImage, { imageUrl: product.mainImageUrl, displayName: product.content.displayName, size: "tiny" })),
            React.createElement("div", { className: styles.product_list__title },
                React.createElement("h5", null, product.title),
                React.createElement("span", null, product.supplier)),
            React.createElement("div", { className: classnames(styles.product_list__price) },
                React.createElement(Price, { isLoggedIn: isLoggedIn, isSupplierSalesman: isSupplierSalesman, price: selectedVariant.price, productIsInCampaign: product.isInCampaign, selectedVariant: product.isWeightProduct ? product.variants ? product.variants[0] : null : selectedVariant })),
            React.createElement("div", { className: styles.product_list__action },
                React.createElement("a", { href: url, onClick: onProductClick },
                    React.createElement(MyMenigoIcon, { name: "arrow" }))))));
};
export default connect((state, { product }) => {
    const selectedVariant = getSelectedVariant(state, product.variants);
    return {
        selectedVariant,
    };
})(ProductListItem);
